<template>
  <header class="bf-topbar">
    <button class="bf-topbar__burger" @click="stateStoreInstance.onChange" aria-label="Menu">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"></path></svg>
    </button>
    <img class="bf-topbar__logo" :src="logoSrc" alt="Bindfy" />
    <div class="bf-topbar__spacer"></div>
  </header>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

import stateStore from "@/utils/store";
import { useAppTheme } from "@/composables/useTheme";

import logoPurple from "@/assets/img/brand/bindfy_logo_new_purple.png";
import logoWhite from "@/assets/img/brand/bindfy_logo_new_white.png";

export default defineComponent({
  name: "MainHeader",
  setup() {
    const stateStoreInstance = stateStore;
    const { isDark } = useAppTheme();
    const logoSrc = computed(() => (isDark.value ? logoWhite : logoPurple));

    return { stateStoreInstance, logoSrc };
  },
});
</script>

<style lang="scss" scoped>
.bf-topbar {
  display: none;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 120;

  &__burger {
    border: 1px solid var(--border);
    background: var(--surface2);
    border-radius: 10px;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--text2);

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &__logo {
    height: 28px;
    width: auto;
  }

  &__spacer {
    flex: 1;
  }
}

@media only screen and (max-width: 991px) {
  .bf-topbar {
    display: flex;
  }
}
</style>
